import { useRef } from "react";
import { Checkbox, Grid2 } from "@mui/material";
import styles from "./AddSSL.module.scss";
import TyTabs from "../../../../../../../../GlobalComponents/TyTabs/TyTabs";
import CustomInput from "../../../../../../../../GlobalComponents/CustomInput/CustomInput";
import CheckBoxOutlineBlankOutlinedIcon from "@mui/icons-material/CheckBoxOutlineBlankOutlined";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

function BrowseButton({ onFileRead }) {
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (evt) => onFileRead(evt.target.result);
    reader.readAsText(file);
    e.target.value = "";
  };

  return (
    <>
      <button
        type="button"
        className={styles.browseButton}
        onClick={() => fileInputRef.current.click()}
      >
        Browse File
      </button>
      <input
        ref={fileInputRef}
        type="file"
        accept=".pem,.key,.crt,.cer,.txt"
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
    </>
  );
}

export function AddSSL(props) {
  const {
    setSslData,
    ssldata,
    privateKeyError,
    certificateChainError,
    sslAutoData,
    sslAutoDataErr,
    setSSLAutoData,
    tos,
    setTos,
    cardStatus,
    selectTab,
    domainName,
  } = props;

  return (
    <>
      <Grid2 className={styles.AddSSLContainer}>
        <Grid2 className={styles.TyTabs}>
          <TyTabs
            selectedTab={cardStatus}
            setSelectedTab={selectTab}
            tabs={[
              { title: "Auto SSL", value: "AutoSSL" },
              { title: "Upload SSL", value: "UploadSSL" },
            ]}
          />
        </Grid2>
        {cardStatus.value === "AutoSSL" && (
          <>
            <CustomInput
              title="Domain Name"
              placeholder="Enter Domain Name"
              value={sslAutoData.domainName || domainName}
              setValue={(e) =>
                setSSLAutoData({ ...sslAutoData, domainName: e })
              }
              error={sslAutoDataErr.domainName}
              disabled={true}
            />
            <CustomInput
              title="Email Id"
              placeholder="Enter Email Id"
              value={sslAutoData.email}
              setValue={(e) => setSSLAutoData({ ...sslAutoData, email: e })}
              error={sslAutoDataErr.email}
            />

            <Grid2 className={styles.AutoSSLtext}>
              <Grid2 className={styles.text}>SSL Certificate: </Grid2>
              <Grid2 className={styles.text1}>
                We provision pem formatted certificates
              </Grid2>
            </Grid2>
            <Grid2 className={styles.checkBoxContainer}>
              <Checkbox
                icon={
                  <CheckBoxOutlineBlankOutlinedIcon
                    className={styles.checkBoxIcon}
                  />
                }
                checkedIcon={<CheckBoxIcon />}
                value={tos}
                onChange={(e) => setTos(e.target.checked)}
              />
              <Grid2 className={styles.footerText}>
                By proceeding, you agree to{" "}
                <a
                  className={styles.checkBoxText}
                  onClick={() => {
                    window.open(
                      "https://letsencrypt.org/documents/LE-SA-v1.2-November-15-2017.pdf",
                      "_blank",
                    );
                  }}
                >
                  Let's Encrypt™ Terms of Service.
                </a>
              </Grid2>
            </Grid2>
          </>
        )}
        {cardStatus.value === "UploadSSL" && (
          <>
            <CustomInput
              title="Private Key"
              placeholder="Paste or upload your private key (PEM format)"
              value={ssldata.privateKey}
              setValue={(e) => setSslData({ ...ssldata, privateKey: e })}
              error={privateKeyError}
              multiline={true}
              titleAction={
                <BrowseButton
                  onFileRead={(val) => setSslData({ ...ssldata, privateKey: val })}
                />
              }
            />
            <CustomInput
              title="Certificate Chain"
              placeholder="Paste or upload your certificate chain (PEM format)"
              value={ssldata.certificateChain}
              setValue={(e) => setSslData({ ...ssldata, certificateChain: e })}
              error={certificateChainError}
              multiline={true}
              titleAction={
                <BrowseButton
                  onFileRead={(val) => setSslData({ ...ssldata, certificateChain: val })}
                />
              }
            />
          </>
        )}
      </Grid2>
    </>
  );
}
